The email address.

This field has a maximum length of 255 bytes in UTF-8 encoding.
